export const environment = {
  production: false,
  backendHost: 'https://stage-kyc.ataix.com',
  backendUrl: 'https://stage-kyc.ataix.com/API/v2',
  pescheckHost: 'https://kyc.pescheck.me',
};
